import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-stock-in-request/")({
	component: () => null,
});
